import React, { useState } from 'react';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, TextField, Tooltip, Typography } from '@mui/material';
import { Button, Form, Input, Select, Space, Spin } from 'antd';
import Table, { ColumnsType } from 'antd/es/table';
import { Add, Delete, OpenInFull, Refresh } from '@mui/icons-material';
import Datas from "../../../../Data/Data.json"
import { Crypter } from '../../../../Functions/Security/Crypter';
import { useAuthHeader } from '../../../../Services/Auth/sessionAuth';
import axios from 'axios';
import SweetAlert from "sweetalert2"
import { FormProvider, useForm } from 'react-hook-form';
import Data from '../../../../Data/Data.json'
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchInput from '../../../SearchInput';
import SearchModal from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import ShowFile from '../../../ShowFile';
import Relation from '../../../../Models/Relation';
import RELATION from '../../../../Models/Relation';

interface SelectData{
  value: string,
  label: string,
}


let searchTypAdr:Params={CodeAgence:'',Table: "TYPADR",Colonne1:"CODTYPE",Colonne2:"LIBELL1",Colagence:'001',Choix:22} 
let searchAgence:Params={CodeAgence:'',Table: "AGENCE",Colonne1:"CODAGE",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGroup:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}


function Tab3(props:{form?: any}){
  const [avlistes,setAvalistes]=React.useState<SelectData[]>([]);
  const [Donnee,setDonnee]=React.useState<RELATION[]>([]);
  //const [pageIsLoad, setPageIsLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [NumRel, setNumRel] = useState<string>();

  // USER TOKEN
  const authHeader = useAuthHeader()

  // if(localStorage.length == 0){
  //   setDonnee([])
  // }

  const columns: ColumnsType<RELATION> = [
    {
      title: 'N° Relation',
      dataIndex: 'NumRel',
      key: 'NumRel'
    },
    {
      title: 'Numéro carte',
      dataIndex: 'cni',
      key: 'cni',
      render: (text) => <a>{text}</a>,
    },
    {
      title: 'Téléphone',
      dataIndex: 'TelRel',
      key: 'TelRel',
    },
    {
      title: 'Adresse',
      dataIndex: 'adresRel',
      key: 'adresRel',
    },
    {
      title: 'Nom Avaliste',
      dataIndex: 'NomRel',
      key: 'codeProfil',
    },
    {
      title: 'Date Naissance',
      dataIndex: 'dateNais',
      key: 'codeProfil',
    },
    {
      title: 'Photo',
      key: 'viewPhoto',
      render: (_, record) => (
        record.photo? 
        <Space size="middle">
          <Tooltip title='Ouvrir le fichier'>
            <ShowFile file={record.photo} fileName={record.NomRel+'-'+record.NumRel} />
          </Tooltip>
        </Space>
        :
        "No file"
      ),
    },
    {
      title: 'Signature',
      key: 'viewSignature',
      render: (_, record) => (
        record.signature? 
        <Space size="middle">
          <Tooltip title='Ouvrir le fichier'>
            <ShowFile file={record.signature} fileName={record.NomRel+'-'+record.NumRel} />
          </Tooltip>
        </Space>
        :
        "No file"
      ),
    },
  ];
  
  

//   const columns: ColumnsType<DataType> = [
//   {
//     title: 'Numéro Indice',
//     dataIndex: 'CODUTI',
//     key: 'codeUser',
//     render: (text) => <a>{text}</a>,
//   },
//   {
//     title: 'Valeur Garantie',
//     dataIndex: 'CODAGE',
//     key: 'codeAgence',
//   },
//   {
//     title: 'Numéro Compte',
//     dataIndex: 'CODGROUP',
//     key: 'codeProfil',
//   },
//   {
//     title: 'Désignation',
//     dataIndex: 'CODGROUP',
//     key: 'codeProfil',
//   },
//   {
//     title: 'Date Début',
//     dataIndex: 'CODGROUP',
//     key: 'codeProfil',
//   },
//   {
//     title: 'Date Fin',
//     dataIndex: 'CODGROUP',
//     key: 'codeProfil',
//   },
//   {
//     title: 'Action',
//     key: 'action',
//     render: (_, record) => (
//       <Space size="middle">
//         <Tooltip title='Retirer de la liste'>
//         <Button color='error' icon={<Delete color='error' />} onClick={()=>{
//           let newRows : DataType[] = [];
//           //newRows.pop((d)=> d.codage == record.codage && d.codgroup == record.codgroup)
//            Donnee.map((d)=>{
//             if(!(d.CODAGE == record.CODAGE && d.CODGROUP == record.CODGROUP)){
//               newRows.push(d)
//             }
//           })
          
//           setDonnee(newRows)
//           localStorage.setItem(Data.LocalVariable.userDistanceHabillitation, Crypter.encrypt(JSON.stringify(newRows)))
          
//           //localStorage.setItem(Datas.LocalVariable.groupPlanCp, Crypter.encrypt(JSON.stringify(d)))
//         }} />
//         </Tooltip>
//       </Space>
//     ),
//   },
// ];

  const handleChangeGarantie = (value: string) => {
    setNumRel(value);
  };

  // if(pageIsLoad){
  //     //alert(Data.ApiUrl.authentification)
  //     setPageIsLoad(false)
  // }

  function loadRelation(){
      try{
        
        const datat: SelectData[] = [];
        var gats = JSON.parse((Crypter.decrypt(localStorage.getItem("avalistes_client")+"")))
        
        //alert(gats)
        
        if(gats.length===0){
          //console.log("aucun élément ");
          setAvalistes(datat)
        }
        else{
          gats.map((data : RELATION)=>{ 
            //console.log(JSON.stringify(data))
            datat.push({
              value: data.NumRel,
              label: data.NumRel+' - '+ data.NomRel,
            });
            setAvalistes(datat);  
          })
        }
      }catch(error){
        //SweetAlert.fire({title: "Veillez sélectionnez le client donc vous voulez charger les garantie", icon: "warning"})
        setNumRel('')
        setAvalistes([])
      }
  }

  function add(){
    //alert(NUMIDENTI)
    if (NumRel) {
      if (Donnee.find((d)=>d.NumRel == NumRel)) {
        SweetAlert.fire({title : "Cet avaliste existe déjà", icon : "warning"})
      }
      else{
        
        let gats  = JSON.parse((Crypter.decrypt(localStorage.getItem("avalistes_client")+"")))
        let newData = {key: "0", ...gats.find((d : any)=>d.NumRel == NumRel)}
        setDonnee([...Donnee, newData]);
        localStorage.setItem(Data.LocalVariable.avaliste, Crypter.encrypt(JSON.stringify([...Donnee, newData])))
        //console.log(Donnee)
      }
    }
    else{
      SweetAlert.fire({title : "Veillez sélectionner les éléments indiqués", icon : "warning"})
    }
  }

  function loadData(){
    try{
      let data = JSON.parse(Crypter.decrypt(localStorage.getItem(Data.LocalVariable.avaliste)+""))
      //alert(JSON.stringify(data))
      setDonnee(data)

    }catch(error){
      console.log(error)
    }
  }
  setTimeout(() => {
    if (Donnee.length == 0) {
      loadData()
      loadRelation()
    }
    try{
      let reset = localStorage.getItem(Datas.LocalVariable.reset)
      if (reset == "1") {
        setAvalistes([])
        setDonnee([])
        setNumRel("")
        localStorage.removeItem(Data.LocalVariable.avaliste)
        //localStorage.clear()
      }
    }
    catch(error){}
  }, .1);
  
  let searchGarantieForm:Params={CodeAgence:'',Table: "V_CGARANTIE",Colonne1:"NUMIDENTI",Colonne2:"DESIGNATION",Colagence:'101',Choix:22}

  return(
    
    <Spin spinning={loading} size='large' style={{color:'green'}} >
           <div className='tabItem'>
      <div>
        <Box  fontStyle="inherit">
         <Box fontStyle="inherit" className = 'border-left border' width={"85%"} position={"absolute"}>
          
              <legend>Avaliste Pret</legend>
              <div>
              <Table size='small' columns={columns} pagination={{ pageSize: 5, position: ["bottomRight"] }} dataSource={Donnee} />
              </div>
            </Box>  
        </Box>
      </div>
    </div> 
  </Spin>
);
}

export default Tab3;